// CIN-15167: `?date=` comes from crawlers and old links, so only a real yyyy-MM-dd day may reach
// format.dateTime, which throws FORMATTING_ERROR on an Invalid Date.
export function parseProgramDate(value: string | undefined): Date | null {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return null;
    }
    const date = new Date(value);
    // new Date() accepts 2026-02-30 by rolling over only in some engines; the round trip rejects it.
    return Number.isFinite(date.getTime()) && date.toISOString().startsWith(value) ? date : null;
}
